import React, { useState, useEffect } from "react";
import { Button, Card, CardHeader, CardBody, CardTitle, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Table, UncontrolledTooltip } from "reactstrap";
import { useAuth } from "context/authContext.js";
import { msalInstance, loginRequest } from "authConfig.js";
import BeatLoader from "react-spinners/BeatLoader";
import { useAccessToken } from "context/tokenConfig.js";
import { baseurl } from "authConfig.js";
import { useClient } from "context/clientContext";
import ClientSelection from "components/SelectClient";
import { useHasChecked } from "context/hasCheckedContext";
import FolderTable from "./components/FolderTable.js"

const Payroll = () => {

  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [awaitingArray, setAwaitingArray] = useState([]);
  const [authorisedArray, setAuthorisedArray] = useState([]);
  const { login } = useAuth();
  const [selectedClientFileId, setSelectedClientFileId] = useState()
  const [action, setAction] = useState(null);
  const [previousFileSize, setPreviousFileSize] = useState()
  const [currentFileSize, setCurrentFileSize] = useState()
  const [mostRecentUploadDate, setMostRecentUploadDate] = useState()
  const [selectedClientId, setSelectedClientId] = useState()
  const [archivedFiles, setArchivedFiles] = useState([])
  const { accessToken } = useAccessToken();
  const [data, setData] = useState([])
  const [lastUpdated, setLastUpdated] = useState()
  const [updatedAwaitingArray, setUpdatedAwaitingArray] = useState([]);
  const [updatedAuthorisedArray, setUpdatedAuthorisedArray] = useState([])
  const { client, selectedClient } = useClient();
  const { hasChecked, setHasChecked } = useHasChecked()

  const toggleModal = () => setModal(!modal);

  const handleLogin = () => {
    msalInstance
      .loginPopup(loginRequest)
      .then(async (response) => {
        console.log("Login successful:", response);
        await login(); 
        window.location.reload();
      })      
      .catch(error => {
        console.error("Login error:", error);
      });
  };
  

  const getDocumentData = async () => {
    setIsLoading(true)
    try {
      const url = `${baseurl}/GetWebPresentationData?ClientId=${selectedClient}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setData(data);
        setIsLoading(false)
      } else {
        console.error('Failed to fetch document data', response.status);
        setIsLoading(false)
      }
    } catch (error) {
      console.error("Error in getDocumentData:", error);
      setIsLoading(false)
    }
  };

  useEffect(() => {
    if (accessToken && selectedClient !== -1) {
      getDocumentData();
    }

    if (selectedClient > 0) {
      setHasChecked(true)
    }
  }, [accessToken, selectedClient]);


  const handleClick = (chosenAction, clientFileId, clientId) => {
    setAction(chosenAction);
    setSelectedClientFileId(clientFileId); 
    setSelectedClientId(clientId)
    toggleModal();
  };

  const uploadFile = async (clientFileId) => {
    try {
      const url = `${baseurl}/ProcessFile?ClientFileID=${clientFileId}&RunDummyIncrementer=1&Action=Authorise&ClientId=${selectedClient}`;
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });
  
      if (response.ok) {
        console.log("File uploaded successfully:", response);

      } else {
        throw new Error('File upload failed');
      }
    } catch (error) {
      console.error("Error in uploadFile:", error);
    } finally {
      getDocumentData();
    }
  };
  
  
  const rejectFile = async (clientFileId) => {
    try {
      const url = `${baseurl}/ProcessFile?ClientFileID=${clientFileId}&RunDummyIncrementer=1&Action=Reject&ClientId=${selectedClient}`;
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
           Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });
  
      if (response.ok) {
        console.log("File uploaded successfully:", response);
        
      } else {
        throw new Error('File upload failed');
      }
    } catch (error) {
      console.error("Error in uploadFile:", error);
    } finally {
      getDocumentData();
    }
  };


  const handleConfirm = () => {
    if (action === "upload") {
      uploadFile(selectedClientFileId); 
    } else {
      rejectFile(selectedClientFileId); 
    }
    toggleModal();  
  };


  useEffect(() => {
    
    const typeOfFile = data.filter(item => item?.folderLabel?.toLowerCase() === "payroll");

    const awaiting = typeOfFile?.filter(item => item?.authorisedDate === null);
    const authorised = typeOfFile?.filter(item => item?.authorisedDate !== null);
  
    const previousFile = typeOfFile.filter(item => item?.clientFileStage === "P");
    const currentFile = typeOfFile.filter(item => item?.clientFileStage === "C");

    const filteredPandC = [...previousFile, ...currentFile];

    const archivedFile = typeOfFile.filter(item => item?.clientFileStage === "A");
  
    const recentDate = typeOfFile
      .map(item => new Date(item?.authorisedDate))
      .filter(date => !isNaN(date))
      .reduce((max, date) => (date > max ? date : max), new Date(0));
  
    const isDefaultDate = recentDate.toISOString() === "1970-01-01T00:00:00.000Z";
    
  const lastUpdated = isDefaultDate
    ? "Never"
    : (() => {
        const now = new Date();
        const currentUTC = new Date(
          Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
        );

        const recentUTC = new Date(
          Date.UTC(recentDate.getUTCFullYear(), recentDate.getUTCMonth(), recentDate.getUTCDate())
        );

        const timeDifference = currentUTC - recentUTC;
        const dayDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

        if (dayDifference === 0) {
          return "Today";
        } else if (dayDifference === 1) {
          return "One Day Ago";
        } else {
          return `${dayDifference} Days Ago`;
        }
      })();
  
    setAwaitingArray(awaiting);
    setAuthorisedArray(filteredPandC);
    setPreviousFileSize(previousFile);
    setCurrentFileSize(currentFile);
    setArchivedFiles(archivedFile)
    setMostRecentUploadDate(recentDate);
    setLastUpdated(lastUpdated);
  
  }, [data]);


  useEffect(() => {
    const updatedArray = awaitingArray.map(item => {
      const isDuplicate =
        authorisedArray.some(
          authItem =>
            authItem.filename === item.filename && authItem.fileSize === item.fileSize
        ) ||
        archivedFiles.some(
          archivedItem =>
            archivedItem.filename === item.filename && archivedItem.fileSize === item.fileSize
        );
  
      return { ...item, hasDuplicate: isDuplicate };
    });
  
    const sortedDocuments = updatedArray.sort((a, b) => {
      return new Date(b.uploadDate) - new Date(a.uploadDate);
    });
  
    setUpdatedAwaitingArray(sortedDocuments);

    const sortedAuthDocuments = authorisedArray.sort((a, b) => {
      return new Date(b.uploadDate) - new Date(a.uploadDate);
    });

    setUpdatedAuthorisedArray(sortedAuthDocuments)
  }, [awaitingArray, authorisedArray, archivedFiles]);
  

 const renderTable = (data) => (
  <Table>
    <thead>
      <tr>
        <th colSpan="3"></th>
        <th colSpan="3" style={{ borderBottom: "1px solid #EC2B20", textAlign: "center", fontWeight: "bold", color: "#EC2B20" }}>
          Validation Failures
        </th>
        <th></th>
      </tr>
      <tr style={{ color: "#201E1F" }}>
        {selectedClient === 0 && <th>Client Name</th>}
        <th>File Name</th>
        <th>Created On</th>
        <th>File Size (MB)</th>
        <th>File Type</th>
        <th>File Size (%)</th>
        <th>Duplicate File</th>
        <th>Authorise</th>
      </tr>
    </thead>
    <tbody>
      {data.map((i, index) =>
        i.clientFileStage === "R" ? null : (
          <tr key={index}>
            {selectedClient === 0 && <td>{i?.clientName}</td>}
            <td>{i?.filename}</td>
            <td>{new Date(i?.fileCreatedDate).toLocaleDateString("en-GB")}</td>
            <td>{i?.fileSize}</td>
            <td>{i?.failedFileExtensionCheck ? "Yes" : "No"}</td>
            <td>{i?.failedFileSizeTolerance ? "Yes" : "No"}</td>
            <td>{i?.hasDuplicate ? "Yes" : "No"}</td>
            <td> <div className="mb-2" pb={6} style={{ display: "flex", flexDirection: "row", paddingRight: "10px" }}> <div className="icon-big text-start icon-warning" style={{ cursor: "pointer" }} onClick={() => handleClick("upload", i?.clientFileID, i?.clientId)} id="toolUp" > <i style={{ color: "#EC2B20", fontSize: "25px" }} className="nc-icon nc-check-2" /> </div> <UncontrolledTooltip placement="right" target="toolUp"> Authorise </UncontrolledTooltip> <div style={{ marginRight: "10px" }}></div> <div className="icon-big text-start icon-warning" style={{ cursor: "pointer" }} onClick={() => handleClick("reject", i?.clientFileID, i?.clientId)} id="toolReject" > <i style={{ color: "#EC2B20", fontSize: "25px" }} className="nc-icon nc-simple-remove" /> </div> <UncontrolledTooltip placement="right" target="toolReject"> Reject </UncontrolledTooltip> <Modal isOpen={modal} toggle={toggleModal} style={{ marginTop: "150px" }}> <ModalHeader toggle={toggleModal}>Are You Sure?</ModalHeader> <ModalBody> {action === "upload" ? "Are you sure you want to authorise the file?" : "Are you sure you want to reject the file?"} </ModalBody> <ModalFooter> <Button color={action === "upload" ? "danger" : "danger"} onClick={handleConfirm}> {action === "upload" ? "Authorise File" : "Reject File"} </Button>{' '} <Button color="secondary" onClick={toggleModal}>Cancel</Button> </ModalFooter> </Modal> </div> </td>
          </tr>
        )
      )}
    </tbody>
  </Table>
);

  return (
    <>
      <div className="content">
      {isLoading ?
      <div style={{ paddingTop: '150px', display: "flex", justifyContent: "center" }}>
          <BeatLoader color={"#EC2B20"} size={35} loading={isLoading} />
      </div>
      :
      <>
        {accessToken === null ?
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "100px 50px 100px 50px" }}>
            <p style={{ fontSize: "20px" }}>
              Please log in to use this app
            </p>

            <Button
              onClick={handleLogin}
              style={{ backgroundColor: "#EC2B20", width: "25%" }}
              block
              className="btn-round"
            >
              Log In
            </Button>
          </div>
          :
            <>
  {client === 0 && !hasChecked ? (
    <ClientSelection />
  ) : (
    hasChecked && (
                    <>
            <Row>
              <Col lg="6" md="6" sm="6">
                <Card className="card-stats">
                  <CardBody style={{ paddingBottom: "10px" }}>
                    <Row>
                      <Col md="2" xs="2">
                        <div className="icon-big text-center icon-warning">
                          <i style={{ color: "#EC2B20" }} className="nc-icon nc-calendar-60" />
                        </div>
                      </Col>
                      <Col md="10" xs="10">
                        <div className="numbers">
                          <p className="card-category">Last Updated</p>
                          <CardTitle style={{ fontSize: "20px", paddingTop: "10px" }} tag="p">{lastUpdated}</CardTitle>
                          <p />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

            </Row>
<FolderTable
  data={updatedAwaitingArray}
  title="Awaiting Authorisation"
  renderTable={renderTable}
  emptyMessage="No files awaiting authorisation"
/>

  <FolderTable
  data={updatedAuthorisedArray}
  title="Recently Committed Payroll Files"
  renderTable={(rows, handleSort, sortConfig) => (
    <Table>
  <thead className="text-primary">
        <tr style={{ color: "#2c2c2c" }}>
          {selectedClient === 0 && (
            <th>
              Client Name
              <button
                style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
                onClick={() => handleSort("clientName")}
              >
                {sortConfig.key === "clientName" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
              </button>
            </th>
          )}
          <th>
            File Name
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("filename")}
            >
              {sortConfig.key === "filename" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            File Stage
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("clientFileStage")}
            >
              {sortConfig.key === "clientFileStage" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            Date Created
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("fileCreatedDate")}
            >
              {sortConfig.key === "fileCreatedDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            Uploaded Date
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("uploadDate")}
            >
              {sortConfig.key === "uploadDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            File Size (MB)
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("fileSize")}
            >
              {sortConfig.key === "fileSize" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((j, index) => (
          <tr key={index}>
            {selectedClient === 0 && <td>{j?.clientName}</td>}
            <td>{j.filename}</td>
            <td>{j.clientFileStage === "P" ? "Previous" : "Current"}</td>
            <td>{new Date(j?.fileCreatedDate).toLocaleDateString("en-GB")}</td>
            <td>{new Date(j?.uploadDate).toLocaleDateString("en-GB")}</td>
            <td>{j.fileSize}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )}
  emptyMessage="No recently committed payroll files"
/>

       <FolderTable
  data={archivedFiles}
  title="Archived Files"
  renderTable={(rows, handleSort, sortConfig) => (
    <Table>
  <thead className="text-primary">
        <tr style={{ color: "#2c2c2c" }}>
          {selectedClient === 0 && (
            <th>
              Client Name
              <button
                style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
                onClick={() => handleSort("clientName")}
              >
                {sortConfig.key === "clientName" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
              </button>
            </th>
          )}
          <th>
            File Name
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("filename")}
            >
              {sortConfig.key === "filename" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            File Stage
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("clientFileStage")}
            >
              {sortConfig.key === "clientFileStage" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            Date Created
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("fileCreatedDate")}
            >
              {sortConfig.key === "fileCreatedDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            Uploaded Date
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("uploadDate")}
            >
              {sortConfig.key === "uploadDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            File Size (MB)
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("fileSize")}
            >
              {sortConfig.key === "fileSize" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((j, index) => (
          <tr key={index}>
            {selectedClient === 0 && <td>{j?.clientName}</td>}
            <td>{j.filename}</td>
            <td>Archived</td>
            <td>{new Date(j?.fileCreatedDate).toLocaleDateString("en-GB")}</td>
            <td>{new Date(j?.uploadDate).toLocaleDateString("en-GB")}</td>
            <td>{j.fileSize}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )}
  emptyMessage="No archived files"
/>
            </>
))
}
            </>
}

          </>
        }

      </div>
    </>
  );
}

export default Payroll;
